import { Injectable } from '@angular/core';

import { OrganizationMenuSummaryDto } from '../../modules/organizations/dtos/organization-menu-summary';

@Injectable({
	providedIn: 'root',
})
export class OrgSelectorService {
	organizationName: string = '';
	organizationsNames: Map<string, string> = new Map();
	tabNavigation: string | null = null;
	private organizationId!: string;
	private userOrganization!: string;

	getOrganizationId(): string {
		return localStorage.getItem('org-id') || (this.organizationId ?? 'na');
	}

	getOrganizationName(): string {
		return localStorage.getItem('org-name') || (this.organizationName ?? '');
	}

	getUserOrganization(): string {
		return this.userOrganization ?? 'na';
	}

	setNavigationTab(tab: string | null): void {
		this.tabNavigation = tab;
	}

	setOrganizationId(id: string): void {
		localStorage.setItem('org-id', id);
		this.organizationId = id;
	}

	setOrganizationName(name: string): void {
		localStorage.setItem('org-name', name);
		this.organizationName = name;
	}

	setOrganizationsNames(organizations: OrganizationMenuSummaryDto[]): void {
		this.organizationsNames = new Map();
		organizations.forEach((organization) => {
			this.organizationsNames.set(organization.id, organization.name_secondary);
		});
	}

	setUserOrganization(id: string): void {
		this.userOrganization = id;
	}
}
